import Vue from "vue";
import Router from "vue-router";
import { getCookies, setCookies, removeCookies, setLocalStorage } from "@/common/auth";
import request from "@/models/request.js"

// 懒加载方式，当路由被访问的时候才加载对应组件
Vue.use(Router);

window.mobilecheck = function() {
    var check = false;
    (function(a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true
    })(navigator.userAgent || navigator.vendor || window.opera)
    return check
}

const whiteList = ["/login"];

let router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            redirect: "/home",
        },
        {
            path: "/login",
            name: "login",
            meta: { title: "登录" },
            component: resolve => {
                require(["@/view/User/login.vue"], resolve);
            },
        },
        {
            path: "/home",
            name: "home",
            meta: { title: "首页" },
            component: resolve => {
                require(["@/view/Home/home.vue"], resolve);
            },
        },
        {
            path: "/account-exception",
            name: "accountException",
            meta: { title: "账号异常" },
            component: resolve => {
                require(["@/view/Home/account-exception.vue"], resolve);
            },
        },
        {
            path: "/tenants-settled-status",
            name: "tenantsSettledStatus",
            meta: { title: "商户入驻" },
            component: resolve => {
                require(["@/view/Tenants/tenants-settled-status.vue"], resolve);
            },
        },
        {
            path: "/tenants-settings",
            name: "tenantsSettings",
            meta: { 
                title: "商户资料"
            },
            component: resolve => {
                require(["@/view/Tenants/tenants-settings.vue"], resolve);
            },
        },
        {
            path: "/orders-list",
            name: "ordersList",
            meta: { 
                title: "订单列表",
                keepAlive: true, // 需要被缓存
                isBack: false //用于判断上一个页面是哪个
            },
            component: resolve => {
                require(["@/view/Orders/orders-list.vue"], resolve);
            },
        },
        {
            path: "/orders-detail",
            name: "ordersDetail",
            meta: { 
                title: "订单详情",
                keepAlive: true, // 需要被缓存
                isBack: false //用于判断上一个页面是哪个 
            },
            component: resolve => {
                require(["@/view/Orders/orders-detail.vue"], resolve);
            },
        },
        {
            path: "/orders-collection",
            name: "ordersCollection",
            meta: { title: "收款" },
            component: resolve => {
                require(["@/view/Orders/orders-collection.vue"], resolve);
            },
        },
        {
            path: "/webview",
            name: "webview",
            meta: { title: "Webview" },
            component: resolve => {
                require(["@/view/Common/webview.vue"], resolve);
            },
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0,
            };
        }
    },
});

// 是否跳过统计页面
var byPass = 0;
var lastPath = '';
var pathList = ['/webview']

router.beforeEach((to, from, next) => {

    if(pathList.indexOf(to.path) > -1) {
        byPass = 1;
        lastPath = to.path;
        next()
        return;
    }

    if(byPass > 0) {
        next({
            path: lastPath
        })
        byPass = 0;
        return;
    }
    
    if (to.path.startsWith("/login")) {
        let token = getCookies("token")
        if (token) {
            next({
                path: "/",
            });
        } else {
            next();
        }
    } else {
        let token = getCookies("token")
        if (token || whiteList.indexOf(to.path) > -1) {
            next();
        } else {
            next({
                path: "/login",
            });
        }
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js